var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"新户自动化上线","name":"first"}},[_c('adsOnlineAutoList')],1),_c('el-tab-pane',{attrs:{"label":"(旧)新户自动化上线","name":"second"}},[_c('newUserOnline')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }